import { buildSummerSplash2026CampaignFlex } from "./flex/SummerSplash2026CampaignFlex";
import { buildSummerSplash2026StickerFlex } from "./flex/SummerSplash2026StickerFlex";
import type { ShareCampaignBuilder } from "./types";

// share_code → 分享訊息產生器。之後新增活動：在 flex/ 新增一個檔案，再於此註冊。
export const shareCampaigns: Record<string, ShareCampaignBuilder> = {
	SummerSplash2026Campaign: buildSummerSplash2026CampaignFlex,
	SummerSplash2026Sticker: buildSummerSplash2026StickerFlex,
};
